import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../../../../../shared/_services/user-management.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-user-management-list',
  templateUrl: './user-management-list.component.html',
  styleUrls: ['./user-management-list.component.scss']
})
export class UserManagementListComponent implements OnInit {
  index: any;
  public lsaAdminList = [];
  lsaid: any;
  isDesc: boolean = false;
  column: string = 'firstName';
  direction: number;
  tableHeader: any = [
    { 'key': 'Name + Phone Number', 'value': 'firstName', 'isDesc': false  },
    { 'key': 'Email ID', 'value': 'email', 'isDesc': true  },
    { 'key': 'Status', 'value': 'status', 'isDesc': true  },
  ];
  constructor(
    public router: Router,
    private usermanagementservice: UserManagementService
  ) { }

  showLsaAdminList(sort) {
    this.usermanagementservice.showLsaAdmins().subscribe(
      res => {
        console.log(res);
        if(res.error == 0) {
          this.lsaAdminList = res.responseObj ? res.responseObj : [];
          if(sort) {
            this.sortTable(this.column);
          } else {
            return;
          }
        } else {
          this.lsaAdminList = [];
        }
      }, error => {
      });
  }

  deactivateLsaId(id,index) {
    this.lsaid = id;
    this.index=index;
  }

  changeLsaStatus(status) {
    const id = this.lsaid;
    console.log(this.lsaid);
    console.log(status);
    this.usermanagementservice.changeLsaStatus(id, status).subscribe(
      data => {
        document.getElementById('deleteModal').click();
        document.getElementById('activateModal').click();
        if(status == "Activate"){
          this.lsaAdminList[this.index].status = "Active";
        }
        else{
          this.lsaAdminList[this.index].status = "Inactive";
        }

        // this.showLsaAdminList(false);
      }, error => {
      });
  }

  goToModify(id) {
    this.router.navigate([`/user-management-list/${id}`]);
  }
  sortTable(property: any) {
    this.tableHeader.forEach((header: any) => {
        if (header.value === property) {
            header.isDesc = header.isDesc ? false : true;
        } if (header.value !== property) {
            header.isDesc = true;
        }
    });
    this.isDesc = !this.isDesc; // change the direction
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  }

  ngOnInit() {
    this.showLsaAdminList(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/user-management/user-management-list/user-management-list.component.ts